import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const CommentPopup = ({
  show = false,
  onHide = () => { },
  onSubmit = () => { },
}) => {
  const [comment, setComment] = useState("");

  const handleCommentChange = (e) => {
    setComment(e.target.value);
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    onSubmit(comment);
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header>
        <Modal.Title>Add Comment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="commentForm.ControlTextarea">
            <Form.Label>Comment:</Form.Label>

            <Form.Control
              as="textarea"
              rows={3}
              value={comment}
              onChange={handleCommentChange}
            />
            <Form.Text className="text-danger">
              *Add a comment to submit the request.
            </Form.Text>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={!comment}>
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CommentPopup;
